export const AGGREMENT = '/agreementadministrator/agreement';





